<ng-container *ngIf="(selectedOrganization$ | async) as selectedOrganization">
  <article class="report">
    <div class="sticky-group">
      <!-- Report Header -->
      <header class="report-header">
        <h1 class="flex-row-group report-org">{{selectedOrganization.name}}</h1>
        <div class="flex-row-group">
          <awair-dropdown-wrapper style="margin-right: 8px;">
            <button class="report__dropdown-btn" dropdown-btn>
              <awair-group-icon></awair-group-icon>
              <span class="report__dropdown-btn-text">{{selectedGroup != null ? selectedGroup.name : 'All Devices'}}</span>
              <awair-caret-down-icon></awair-caret-down-icon>
            </button>

            <awair-dropdown-ul [horizontalAlignment]="HorizontalAlignment.Left" dropdown>
              <!-- All Devices -->
              <li class="report__dropdown-list-item"
                  (click)="selectGroup(null)"
                  [class.report__dropdown-list-item--selected]="selectedGroup == null">All Devices
              </li>
              <!-- /.All Devices -->
              <li class="report__dropdown-divider"></li>
              <!-- Group List -->
              <li class="report__dropdown-list-item"
                  *ngFor="let group of groupList$ | async | objArraySort: 'name'"
                  [class.report__dropdown-list-item--selected]="group.id === selectedGroup?.id"
                  (click)="selectGroup(group)">{{group?.name}}
              </li>
              <!-- /.Group List -->
            </awair-dropdown-ul>
          </awair-dropdown-wrapper>
          <awair-weekpicker
            [since]="since"
            [selectedFromDate]="dateRange.fromDate"
            [selectedToDate]="dateRange.toDate"
            (selectWeek)="onSelectWeek($event)">
          </awair-weekpicker>
        </div>
      </header>
      <!-- /.Report Header -->
      <div class="divider"></div>
    </div>

    <!-- Report Main Section -->
    <section class="report-section" [ngSwitch]="hasReport">
      <awair-loading *ngIf="loading" style="height: 100%;"></awair-loading>
      <awair-report-summary *ngSwitchCase="true"
                            [scoreWeeklyAvg]="scoreWeeklyAvg"
                            [scoreCondition]="scoreCondition"
                            [weeklyAvgList]="weeklyAvgList"
                            [dailyScoreAvgList]="dailyScoreAvgList"
                            [worstFactor]="worstFactor">
      </awair-report-summary>
      <awair-blank-report *ngSwitchCase="false"></awair-blank-report>
    </section>
    <!-- /.Report Main Section -->
  </article>
</ng-container>

